const brand = {
  50: '#FDECEC',
  100: '#FCE3E3',
  200: '#F9C5C5',
  300: '#F38C8C',
  400: '#F45A57',
  500: '#D43C3D',
  600: '#BC3636',
  700: '#B03233',
  800: '#8D2829',
  900: '#521718',
};

const red = {
  50: '#fae9e7',
  100: '#f8dedb',
  200: '#f0bbb5',
  300: '#E1776B',
  400: '#cd230f',
  500: '#b9200e',
  600: '#a41c0c',
  700: '#9a1a0b',
  800: '#7b1509',
  900: '#480c05',
};

const green = {
  50: '#e6f4ed',
  100: '#daefe5',
  200: '#b2dec8',
  300: '#5EBA8D',
  400: '#08934f',
  500: '#078447',
  600: '#06763f',
  700: '#066e3b',
  800: '#05582f',
  900: '#03331c',
};

const yellow = {
  50: '#fff9ec',
  100: '#fff6e3',
  200: '#ffebc4',
  300: '#FFDB94',
  400: '#ffc042',
  500: '#e6ad3b',
  600: '#cc9a35',
  700: '#bf9032',
  800: '#997328',
  900: '#594317',
};

const blue = {
  50: '#ecf1fb',
  100: '#e2eaf9',
  200: '#c3d5f4',
  300: '#7FA4E6',
  400: '#3e76da',
  500: '#386ac4',
  600: '#325eae',
  700: '#2f59a4',
  800: '#254783',
  900: '#16294c',
};

const neutral = {
  50: '#F4F4F4',
  100: '#E7E6E6',
  200: '#D0CECE',
  300: '#B8B5B5',
  400: '#A09C9C',
  500: '#888383',
  600: '#716B6B',
  700: '#595252',
  800: '#413939',
  900: '#3A2D2D',
};

/**
 * This is the latest known version of the colours in our Paper Design System.
 * @link https://www.figma.com/design/FXkrXPU0YKVIIlD9TYQdfR/Paper-Design-System-2024
 */
export const palettenext = {
  black: '#000000',
  white: '#FFFFFF',
  brand,
  red,
  green,
  yellow,
  blue,
  neutral,
};
